import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import Hero from './Hero';
import Services from './Services';
import Philosophy from './Philosophy';
import StrategyLab from './StrategyLab';
import Footer from './Footer';

const App: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0a] selection:bg-white selection:text-black">
      <Navbar scrolled={scrolled} />
      <main>
        <Hero />
        <Services />
        <Philosophy />
        <StrategyLab />
      </main>
      <Footer />
    </div>
  );
};

export default App;
